import React from "react"
import { FC } from "react"
import { TextInput } from "react-native-paper"

export const PaymentCardTextField: FC = () => {
  return <TextInput />
}
